import { data } from "@app/data";

export const useSiteData = () => {
  return {
    ...data,
  };
};
